import { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { PROVIDERS } from '../../../route.const'
import { useAuth } from '@provider/context/AuthContext'
import LoadingError from '@common/LoadingError'

const ProviderWelcome: FC = () => {
  const navigate = useNavigate()
  const { isLoggedIn, loginError } = useAuth()

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/')
    } else {
      navigate(`/${PROVIDERS}/`)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loginError) {
    return <LoadingError isLoading={false} isError={loginError} />
  }

  return <Outlet />
}

export default ProviderWelcome
